
import { Clock, FileText, FolderKanban } from "lucide-react";
import { CoreFeatureCard } from "./CoreFeatureCard";

export function CoreFeaturesSection() {
  const coreFeatures = [
    {
      icon: Clock,
      title: "Time Tracking",
      description: "Track every minute with precision and ease",
      features: [
        "Manual time entry for accuracy",
        "Detailed entry descriptions",
        "Edit historical entries anytime",
        "Track by date, project and client"
      ]
    },
    {
      icon: FolderKanban,
      title: "Project Management",
      description: "Organize work and set custom rates",
      features: [
        "Unlimited projects and clients",
        "Custom hourly rates per project",
        "Project archiving for less clutter",
        "Detailed project analytics"
      ]
    },
    {
      icon: FileText,
      title: "Invoicing",
      description: "Generate professional invoices instantly",
      features: [
        "One-click invoice generation",
        "Monthly invoice summaries",
        "Detailed time breakdown",
        "Downloadable invoice files"
      ]
    }
  ];

  return (
    <section className="py-14 bg-white">
      <div className="container max-w-6xl">
        <h2 className="text-3xl font-bold text-center mb-12">Core Features</h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {coreFeatures.map((feature, index) => (
            <CoreFeatureCard 
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              features={feature.features}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
